import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getCashAccountsInput,
  getCashAccountInput,
  CashAccountLiteModel,
  CashAccountModel,
} from './model';

export function useGetCashAccounts(
  input?: getCashAccountsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<CashAccountLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<CashAccountLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCashAccounts', input?.params],
      () =>
        QueryFetchFunction({
          url: 'cash-accounts',
          params: input?.params,
        }),
      options,
    ),
    CashAccountLiteModel,
  );
}

export function useGetCashAccount(
  input?: getCashAccountInput,
  options?: UseQueryOptions<ApiResult<CashAccountModel>, ApiError>,
): UseQueryResult<ApiResult<CashAccountModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCashAccount', input?.id],
      () => QueryFetchFunction({ url: `cash-accounts/${input?.id}` }),
      options,
    ),
    CashAccountModel,
  );
}

export function getCashAccountsKey(input?: getCashAccountsInput) {
  return ['getCashAccounts', input?.params].filter(Boolean);
}

export function getCashAccountKey(input?: getCashAccountInput) {
  return ['getCashAccount', input?.id].filter(Boolean);
}
